import React from "react";
import Answer from './Answer';
import "./Question.css";

export default class Question extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            'answer_chosen': 0
        };

        this.clickAnswer = this.clickAnswer.bind(this);
    }

    clickAnswer(answer_id) {
        this.setState({
            'answer_chosen': answer_id
        });

        this.props.onComplete();
    }

    render() {
        return (
            <div className={"question " + (this.props.hidden ? "hidden" : "")}>
                <h2>{this.props.question.query}</h2>

                <input type={"hidden"}
                       name={`question-${this.props.question.id}`}
                       value={this.state.answer_chosen}/>

                <div className={"answer-list"}>
                    {this.props.question.answers.map((answer) => (
                        <Answer key={answer.id}
                                text={answer.name}
                                chosen={this.state.answer_chosen === answer.id}
                                onClick={() => {this.clickAnswer(answer.id)}}/>
                    ))}
                </div>
            </div>
        )
    }
}
